<template>
  <div class="page">
    <GlobusTableNavbar
      v-model="searchString"
      :selected-items="selectedItems"
      @open-create-modal="isTagModal = true"
      @open-delete-modal="removeFeed"
      @open-upload-modal="isShowUploadModal = true"
      @save-changes="saveChanges"
    />
    <GlobusTable
      :use-multi-select="true"
      :column-list="tagsColumnList"
      :items="getItems"
    />
    <CreateTag
      v-model:isActive="isTagModal"
      @added="tagsStore.getTags()"
    />
  </div>
</template>

<script setup>
import GlobusTable from "@/components/table/GlobusTable.vue";
import GlobusTableNavbar from "@/components/table/GlobusTableNavbar.vue";
import CreateTag from "@/components/table/CreateTag.vue";
import {computed, onMounted, provide, ref} from "vue";
import { useTags, tagsColumnList } from "@/stores/tags";
import axios from "axios";

const tagsStore = useTags();

const searchString = ref("");

onMounted( () => {
  tagsStore.getTags();
});

// Список элементов для таблицы, в зависимости от значения поисковой строки.
const getItems = computed(() => {
  if (searchString.value.length > 0) {
    return tagsStore.tagList.filter((item) => item.name.toLowerCase().includes(searchString.value.toLowerCase()));
  } else {
    return tagsStore.tagList;
  }
});

// Список элементов, которые были отредактированы. (Для обновления)
const editedItems = ref([]);
provide("editedItems", editedItems);

// Список элементов, которые отмечены чекбоксом. (Для удаления)
const selectedItems = ref([]);
provide("selectedItems", selectedItems);
const isTagModal = ref(false);
const isShowUploadModal = ref(false);

let feedCheckedIds = computed(() => {
  return selectedItems.value.map((item) => item.id);
});

const removeFeed = async () => {
  const confirmed = confirm("Вы действительно хотите удалить выбранные тэги?");  // Предупреждение перед удалением
  if (!confirmed) return; // Отмена удаления

  for (const id of feedCheckedIds.value) {
    try {
      await axios.delete(`/tags/${id}`);
    } catch (err) {
      console.error(err);
    }
    selectedItems.value = [];
  }

  await tagsStore.getTags(); // Обновляем таблицу
};

const saveChanges = async () => {
  if (editedItems.value.length === 0) return false;
  for (let i in editedItems.value) {
    await tagsStore.updateTag(editedItems.value[i]);
  }
  await tagsStore.getTags().then(() => {
    editedItems.value = [];
  });
};
</script>

<style scoped lang="scss">
.page {
    border-radius: 8px;
    padding-bottom: 20px;
    padding-bottom: 5px;
    padding-left: 15px;
    padding-right: 15px;
}
</style>